import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

export const categoryValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value || value.length === 0) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  return null;
};
